import { render, staticRenderFns } from "./AscPlatformTilesWrapper.vue?vue&type=template&id=353e9c9d&scoped=true&"
import script from "./AscPlatformTilesWrapper.vue?vue&type=script&lang=js&"
export * from "./AscPlatformTilesWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscPlatformTilesWrapper.vue?vue&type=style&index=0&id=353e9c9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353e9c9d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
